import store from '../store/index';
import ssoService from '../services/ssoService';

import commonTool from '../utils/commonTool';

const ignoreRoutes = commonTool.getIgnoreRoutes();

// 取得會員權杖
const getAccessToken = function getAccessToken(code) {
  const body = {
    companyId: store.state.companyId,
    memberSourceId: store.state.memberSourceId,
    code,
  };

  return ssoService.getDigest(store.state.companyId, store.state.memberSourceId, body)
    .toPromise()
    .then((res) => {
      const headers = { digest: res.response.data[0].digest };
      return ssoService.getAccessToken(body, headers).toPromise();
    });
};

// 驗證 accessToken
const verifyAccessToken = function verifyAccessToken(cookieName, accessToken, to, next) {
  ssoService.verifiyAccesstoken({ accessToken }).subscribe({
    next(res) {
      // 驗證 OK
      if (res.response.status === '200') {
        // 設定 cookie
        commonTool.setCookie(cookieName, accessToken);
        // 設定 state 內 accessToken
        store.commit('set', { name: 'accessToken', value: accessToken });
        // 設定 memberId
        store.commit('set', { name: 'memberId', value: res.response.data[0].memberID });
        // 有 Code 代表經由 SSO 登入，跳轉登入前頁面 & 把 code 濾掉
        if (to.query.code && !to.query.liffClientId) next({ name: to.name, query: { companyid: to.query.companyid, membersourceid: to.query.membersourceid, activityId: to.query.activityId }, replace: true });
        else next();
      // 登入授權已失效
      } else if (res.response.status === '606') {
        // 兌禮專區，授權失效不跳轉錯誤頁，直接停留原頁
        if (ignoreRoutes.includes(to.name)) {
          next();
          return;
        }

        // 清除 cookie
        commonTool.deleteCookie(cookieName);
        // 跳轉至錯誤頁
        next({ name: 'Error', params: { status: 'accessTokenInvalid' }, query: { path: window.location.pathname } });
      }
    },
    error(err) {
      // 兌禮專區，驗證失敗不登入，直接停留原頁
      if (ignoreRoutes.includes(to.name)) {
        next();
        return;
      }

      // 授權失敗
      if (err.data.status === '401') {
        // 清除 cookie
        commonTool.deleteCookie(cookieName);
        // 重新登入
        commonTool.login(window.location.pathname);
      }
    },
  });
};

export default (to, from, next) => {
  // 錯誤頁，直接跳過後續步驟
  if (to.name === 'Error') {
    next();
    return;
  }

  // companyId、memberSourceId 任一不存在跳轉至錯誤頁
  if (!to.query.companyid || !to.query.membersourceid) {
    next({ name: 'Error' });
    return;
  }

  // 若 state 內無 companyId & memberSourceId 資料則加入
  if (!store.state.companyId || !store.state.memberSourceId) {
    store.commit('set', { name: 'companyId', value: to.query.companyid });
    store.commit('set', { name: 'memberSourceId', value: to.query.membersourceid });
  }

  const cookieName = `accessToken_${store.state.companyId}_${store.state.memberSourceId}`;
  // 從 cookie 中取得 accessToken
  let accessToken = commonTool.getCookie(cookieName);

  // 兌禮專區 & 無 accessToken & 非登入流程，不驗證
  if (ignoreRoutes.includes(to.name) && !accessToken && !to.query.verify) {
    next();
    return;
  }

  // 有 code
  if (to.query.code && !to.query.liffClientId) {
    // 呼叫 API 以 code 取得 accessToken，失敗時跳轉至錯誤頁，引導使用者重新登入
    getAccessToken(to.query.code)
      .then((res) => {
        accessToken = res.response.data[0].accessToken;
        // 驗證 accessToken
        verifyAccessToken(cookieName, accessToken, to, next);
      })
      .catch(() => {
        // 兌禮專區，驗證失敗不登入，直接停留原頁
        if (ignoreRoutes.includes(to.name)) {
          next();
          return;
        }

        next({ name: 'Error', params: { status: 'login' }, query: { path: window.location.pathname } });
      });
    return;
  }

  // 頁面跳轉前驗證 accessToken
  verifyAccessToken(cookieName, accessToken, to, next);
};
